import {Component, HostListener, OnInit} from '@angular/core';
import {WsService} from '../_services/ws.service';

@Component({
  selector: 'app-ws',
  styleUrls: ['./ws.component.scss'],
  templateUrl: './ws.component.html',
})

// THIS COMPONENT IS TO CREATE AND MANAGE THE WS CONNECTION
// IT ALSO PASSES ALL MESSAGES THROUGH TO THE DEPENDENT COMPONENTS

export class WsComponent implements OnInit {

  wsAutobahnActive = false;

  constructor(
    private wsService: WsService,
  ) {
  }

  @HostListener('window:focus', ['$event']) onFocus(event: any): void {
    // ALSO CHECK IF TAB IS VISIBLE
    if (document.visibilityState !== 'hidden') {
      this.wsAutobahnConnect();
    }
  }

  ngOnInit(): void {
    // INIT WS AND SUBSCRIBE TO HOT OBSERVABLES
    this.wsAutobahnConnect();
  }


  // ********************************************************************************************************
  // LOADING DATA
  // ********************************************************************************************************


  // AUTOBAHN
  wsAutobahnConnect(): void {
    if (!this.wsService.wsAutobahn || !this.wsService.wsAutobahn.isConnected || !this.wsService.wsAutobahn.isOpen) {
      this.wsService.wsInit();
      this.wsAutobahnSubscribe();
    } else {
      this.wsAutobahnActive = true;
    }
  }

  wsAutobahnSubscribe(): void {
    this.wsService.onNewWsMessage()
      .subscribe(
        (responseData) => {
          if (responseData.type === 'connected') {
            // DO NOTHING, JUST WS CONNECTING
            this.wsAutobahnActive = true;
          } else if (responseData.type === 'error' || responseData.type === 'disconnected') {
            // DO NOTHING, ERROR OR DISCONNECT => XBAR RECONNECTS AUTOMATICALLY
            this.wsAutobahnActive = false;
          }
        }
      );
  }

  // ********************************************************************************************************
  // CHANGING DATA
  // ********************************************************************************************************

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  // EVENT LISTENERS

  // MISCELLANEOUS

}
